import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceS } from '@xingternal/tokens';
import { Headline } from '@xingternal/typography';

export const StyledTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  @media ${mediaConfined} {
    flex-direction: row;
  }
`;

export const RatingHeadline = styled(Headline)`
  margin-bottom: ${spaceS};
`;
